import {isEqual} from 'lodash/fp';

import {
  DatasourceType,
  InclusionDateType,
  PeriodType,
  PolicyAmountType,
  PolicyStatusType,
} from 'modules/decisionsNext/api/types';
import {AnyRecord} from 'types';

import {CleanEmptyValuesOptions, cleanEmptyValues} from 'utils/cleanEmptyValues';

export const initialFilter = {
  period: {
    amountType: PolicyAmountType.Billed,
    inclusionDateType: InclusionDateType.Transaction,
    type: PeriodType.Rolling_12Months,
  },
  policyStatusType: PolicyStatusType.Ennabl,
  datasourceType: DatasourceType.ProductionCredit,
} as const;

export function isEqualFilters<T extends AnyRecord>(filter1: T, filter2: T, options?: CleanEmptyValuesOptions) {
  return isEqual(cleanEmptyValues(filter1, options), cleanEmptyValues(filter2, options));
}
